import {
  Box,
  Button,
  Card,
  DialogActions,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getMerchantWithActions,
  getPendingMerchant,
  Log,
  PendingMerchantAction,
} from "../../services/services";
import ListHead from "../table/ListHead";
import Scrollbar from "../table/Scrollbar";
import RejectPendingMerchant from "./Dialogs/RejectPendingMerchant";
import { applySortFilter } from "../../utils/tableFunctions";
import { StyledTableRow } from "../TableRow";
import { useLoadingSpinnerContext } from "../../context/loadingSpinnerContext";
import { CustomTableCell } from "../TableCell";
import MerchantDetails from "../../pages/details/admin/MerchantDetails";
import CommonDialog from "../CustomDialog";
import CircularLoader from "../circularLoader";
import { styles } from "../../utils/styles";
import { TablePagination } from "@mui/material";
import { pageNumber, rowsPerPage as defaultRowsPerPage } from "../../utils/constants";
// import { MAPPED_REGISTERED_COUNTRY } from "../../utils/constants";

const TABLE_HEAD = [
  { id: "name", label: "Name" },
  { id: "mid", label: "MID" },
  { id: "business_entity", label: "Business Entity" },
  { id: "oxygen7_entity", label: "Oxygen7 Entity" },
  // { id: "registered_country", label: "Registered Country" },
  { id: "action", label: "Action" },
  { id: "approve" },
];

const PendingMerchant = ({ userRole }) => {
  const { setGlobalLoading } = useLoadingSpinnerContext();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(null);
  const [merchantList, setMerchantList] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [pendingDetails, setPendingDetails] = useState(null);
  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: defaultRowsPerPage,
  });

  // dialogs
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [selectedId, setSelectedId] = useState();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredList = applySortFilter(
    merchantList.results || [],
    order,
    orderBy
  );

  const isItemNotFound = filteredList.length === 0;

  const renderData = data => {
    const newData = data.results.map(item => ({
      ...item,
      business_entity: item.business_entity?.business_name,
      oxygen7_entity: item.oxygen7_entity?.entity,
      // registered_country: item.registered_country?.registered_country
    }))
    setMerchantList({
      ...data,
      results: newData
    });
  }

  const queryPage = (queryParams) => {
    setLoaded(false);
    getPendingMerchant({
      setResponse: renderData,
      setLoaded: setLoaded,
      queryParams: queryParams
    });
    setPagination(queryParams);
  };

  const handleChangePage = (event, newPage) => {
    queryPage({
      page: newPage + 1,
      page_size: pagination.page_size,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage({
      page: 1,
      page_size: parseInt(event.target.value, 10),
    });
  };

  useEffect(() => {
    queryPage(pagination);
  }, []);

  const handleCloseDialog = (shouldResetDetails) => {
    setOpenRejectDialog(false);
    if (shouldResetDetails === true) setPendingDetails(null);
  };
  return (
    <Box>
      {/* <Typography variant="h6" sx={{ mb: 2 }}>Test: PendingMerchant Component is Rendering</Typography> */}
      {loaded ?
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                  checkbox={false}
                />

                <TableBody>
                  {filteredList.map((row) => {
                        const { id, name, mid, business_entity, 
                          oxygen7_entity,
                          // registered_country, 
                          action } = row;

                        return (
                          <StyledTableRow
                            hover
                            key={id}
                          >
                            <CustomTableCell field={name ? name.toUpperCase() : ""} />
                            <CustomTableCell field={mid} />
                            <CustomTableCell field={business_entity ? business_entity.toUpperCase() : ""} />
                            <CustomTableCell field={oxygen7_entity ? oxygen7_entity.toUpperCase() : ""} />
                            {/* <CustomTableCell field={MAPPED_REGISTERED_COUNTRY[registered_country]} /> */}
                            <CustomTableCell field={action ? action : ""} />
                            <TableCell>
                              <Button
                                variant="text"
                                color="secondary"
                                onClick={() => {
                                  setGlobalLoading(true);
                                  getMerchantWithActions(id, setPendingDetails, () => setGlobalLoading(false));
                                }}
                              >
                                View Detail
                              </Button>
                            </TableCell>
                          </StyledTableRow>
                        );
                      })}
                </TableBody>
                {isItemNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            There are no pending merchants at the moment.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={merchantList.count}
            rowsPerPage={pagination.page_size}
            page={pagination.page - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        :
        <CircularLoader />
      }
      {selectedId && (
        <RejectPendingMerchant
          open={openRejectDialog}
          onClose={handleCloseDialog}
          id={selectedId}
          setMerchantList={renderData}
          setLoaded={setLoaded}
        />
      )}

      {pendingDetails && (
        <CommonDialog
          title="Merchant Details"
          onClose={() => setPendingDetails(null)}
          renderActions={() =>
            userRole.includes("Approve/Reject") && (
              <DialogActions>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenRejectDialog(true);
                    setSelectedId(pendingDetails.id);
                  }}
                >
                  Reject
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    setGlobalLoading(true);
                    Log.info(`Click button [Approve] - Approve Merchant by Id: ${pendingDetails.id}`)
                    await PendingMerchantAction(
                      pendingDetails.id,
                      "approve",
                      renderData,
                      setLoaded
                    )
                    setPendingDetails(null);
                    setGlobalLoading(false);
                  }}
                  sx={{ ...styles.customButton }}
                >
                  Approve
                </Button>
              </DialogActions>
            )
          }
        >
          <MerchantDetails detailsData={pendingDetails} />
        </CommonDialog>
      )}
    </Box>
  );
};

export default PendingMerchant;
